import React from 'react'

function OurStore() {
  return (
    <h1>OurStore</h1>
  )
}

export default OurStore